import { useQuery } from "@tanstack/react-query";
import { useDispatch } from "react-redux";
import { getMedicineSaltPharmacySearch } from "../connections/getApi";
import { setError, setLoading } from "../redux/slices/pharmacySlice";

const UseFetchSearchSaltsPharmacy = (q, page, itemPerPage) => {
    const dispatch = useDispatch();

    return useQuery({
        queryKey: ["getMedicineSaltPharmacySearch", q, page, itemPerPage],
        queryFn: () => getMedicineSaltPharmacySearch(q, page, itemPerPage),
        enabled: !!(q || page || itemPerPage),
        // enabled: !!page || !!itemPerPage || !!q,
        onError: () => {
            dispatch(setError(true));
            dispatch(setLoading(false));
        },
        onSettled: () => {
            dispatch(setLoading(false));
        },
    });
};

export default UseFetchSearchSaltsPharmacy;
